import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../components-v2/Theme/theme';
import { white } from '../../../styles/colors';

const {
	colors,
	common: { border, borderRadius },
	spacing,
} = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-start',
	},
	cell: {
		padding: spacing.sm,
	},
	addTagButton: {
		display: 'flex',
		gap: spacing.sm,
		alignItems: 'center',
	},
	actionButtons: {
		alignItems: 'center',
		display: 'flex',
		flexDiretion: 'row',
		margin: 0,
		padding: 0,
		gap: spacing.sm,
	},
	link: {
		color: colors.primary.main,
		textDecoration: 'none',
		fontWeight: 600,
		cursor: 'pointer',
	},
	actionsBar: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '16px 24px',
		borderBottom: border,
	},
	leftActions: {
		display: 'flex',
		gap: spacing.md,
	},
	rightActions: {
		display: 'flex',
		gap: spacing.md,
		justifyContent: 'flex-end',
	},
	deleteConfirmationTag: {
		marginLeft: spacing.sm,
		marginTop: spacing.sm,
		maxWidth: 150,
	},
	deleteConfirmationTags: {
		marginBottom: spacing.md,
		overflow: 'hidden',
	},
	deleteConfirmationTagsContent: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'center',
		margin: '-10px 0 0 -10px',
	},
	loader: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		padding: spacing.lg,
	},
	searchControls: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: spacing.md,
		width: '100%',
		flexWrap: 'wrap',
	},
	searchDescription: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: `0 ${spacing.md}px`,
		background: white,
		border,
		borderRadius,
		fontSize: 14,
		boxSizing: 'content-box',
		width: '100%',
	},
	databoard: {
		flex: 1,
		minHeight: 0,
		background: 'transparent',
		gap: spacing.md,
		marginBottom: spacing.md,
	},
	databoardBody: {
		background: white,
	},
	sortIcon: {
		marginLeft: spacing.sm,
	},
	sortIconFlipped: {
		transform: 'rotate3d(0,0,1, 180deg)',
	},
	sortMenu: {
		gap: spacing.sm,
	},
	sortMenuItem: {
		padding: `${spacing.sm}px ${spacing.md}px`,
		width: '100%',
		display: 'flex',
		':hover': {
			backgroundColor: colors.hover.light,
		},
	},
	sortTrigger: {
		alignItems: 'center',
		cursor: 'pointer',
		display: 'flex',
		fontSize: 12,
		gap: spacing.sm,
		textTransform: 'uppercase',
		fontWeight: 600,
	},
	alert: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.md,
	},
	searchButton: {
		':has(*) > svg': {
			width: 20,
			height: 20,
		},
	},
	searchInput: {
		height: 40,
		minWidth: 348,
	},
	nameColumn: {
		width: '35%',
	},
	contactsColumn: {
		width: '15%',
	},
	companiesColumn: {
		width: '15%',
	},
	tagAlertColumn: {
		width: '35%',
	},
	// Favorite styles
	clickable: {
		cursor: 'pointer',
	},
	favoriteCol: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	favorite: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		cursor: 'default',
		position: 'relative',
	},
	favoriteTrigger: {
		display: 'flex',
		alignItems: 'center',
		gap: SPACE[4],
		padding: SPACE[4],
		borderRadius,
		color: colors.icon.gray,
		':hover:not(:disabled)': {
			backgroundColor: colors.hover.light,
		},
		':focus-visible': {
			outline: `2px solid ${colors.primary.main}`,
		},
		':is([data-popup-open])': {
			backgroundColor: colors.hover.light,
		},
	},
	favoriteTriggerCaret: {
		width: 12,
		height: 12,
	},
	favoriteMenu: {
		minWidth: 200,
	},
	favoriteMenuItem: {
		minHeight: SPACE[32],
		padding: `${SPACE[4]}px ${SPACE[8]}px`,
		fontSize: THEME.typography.fontSizes.sm,
		color: colors.text.dark,
	},
	favoriteRemoveItem: {
		':has(*) svg': {
			width: 16,
			height: 16,
		},
	},
	favoriteMenuItemLabel: {
		display: 'flex',
		alignItems: 'center',
		gap: SPACE[8],
	},
	disclosureIconDesc: {
		transform: 'rotate(90deg)',
		marginLeft: 4,
	},
	disclosureIconAsc: {
		transform: 'rotate(270deg)',
		marginLeft: 4,
	},
	cursorNotAllowed: {
		cursor: 'not-allowed',
	},
	mergeTags: {
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(242, 182, 57, 0.4)`,
		},
	},
	deleteTags: {
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(133, 133, 133, 0.4)`,
		},
	},
	exportTags: {
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(137, 201, 71, 0.4)`,
		},
	},
	removeUnusedTags: {
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(167, 171, 173, 0.4)`,
		},
	},
	reevaluateTaggingGame: {
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(4, 102, 255, 0.4)`,
		},
	},
});
